export const env = {
    googleApiKey:'AIzaSyBcqVZ_mrDfGO-lipw2g1eo5qFXrf9N_As'
}
